import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/live/getList',
        method: 'post',
        data: data
    })
}
export function createUpdate(data) {
    return request({
        url: '/backend/live/createUpdate',
        method: 'post',
        data: data
    })
}
export function getDetail(data) {
    return request({
        url: '/backend/live/getDetail',
        method: 'post',
        data: data
    })
}
export function del(data) {
    return request({
        url: '/backend/live/delete',
        method: 'post',
        data: data
    })
}
export function updateStatus(data) {
    return request({
        url: '/backend/live/updateStatus',
        method: 'post',
        data: data
    })
}

export function updateRightMarkSymbol(data) {
    return request({
        url: '/backend/live/updateRightMarkSymbol',
        method: 'post',
        data: data
    })
}

export function updateSort(data) {
    return request({
        url: '/backend/live/updateSort',
        method: 'post',
        data: data
    })
}

export function getLiveRoomInfo(data) {
    return request({
        url: '/backend/live/getLiveRoomInfo',
        method: 'post',
        data: data
    })
}

export function getLiveEmbedList(data) {
    return request({
        url: '/backend/live/getLiveEmbedList',
        method: 'post',
        data: data
    })
}
export function searchBJYVideoList(data) {
    return request({
        url: '/backend/live/searchBJYVideoList',
        method: 'post',
        data: data
    })
}
export function liveSetEmbedVideo(data) {
    return request({
        url: '/backend/live/liveSetEmbedVideo',
        method: 'post',
        data: data
    })
}
export function liveUnsetEmbedVideo(data) {
    return request({
        url: '/backend/live/liveUnsetEmbedVideo',
        method: 'post',
        data: data
    })
}
export function resetLiveStatus(data) {
    return request({
        url: '/backend/live/resetLiveStatus',
        method: 'post',
        data: data
    })
}
export function getLiveURL(data) {
    return request({
        url: '/backend/live/getLiveURL',
        method: 'post',
        data: data
    })
}
export function setLiveTeacher (data) {
    return request({
        url: '/backend/live/setLiveTeacher',
        method: 'post',
        data: data
    })
}
export function replacePlayback (data) {
    return request({
        url: '/backend/live/replacePlayback',
        method: 'post',
        data: data
    })
}

//普通课直播小节管理
export function createdUpdatePeriod(data) {
    return request({
        url: '/backend/live/createdUpdatePeriod',
        method: 'post',
        data: data
    })
}
export function getPeriodDetail(data) {
    return request({
        url: '/backend/live/getPeriodDetail',
        method: 'post',
        data: data
    })
}

//直播间推广消息管理
export function getMessageList(data) {
    return request({
        url: '/backend/live/getMessageList',
        method: 'post',
        data: data
    })
}
export function deleteMessage(data) {
    return request({
        url: '/backend/live/deleteMessage',
        method: 'post',
        data: data
    })
}
export function updateMessageSort(data) {
    return request({
        url: '/backend/live/updateMessageSort',
        method: 'post',
        data: data
    })
}
export function createUpdateMessage(data) {
    return request({
        url: '/backend/live/createUpdateMessage',
        method: 'post',
        data: data
    })
}
export function getMessageDetail(data) {
    return request({
        url: '/backend/live/getMessageDetail',
        method: 'post',
        data: data
    })
}
export function sendMessage(data) {
    return request({
        url: '/backend/live/sendMessage',
        method: 'post',
        data: data
    })
}
export function messageAddCoupon(data) {
    return request({
        url: '/backend/live/messageAddCoupon',
        method: 'post',
        data: data
    })
}
export function messageSetChannelItem(data) {
    return request({
        url: '/backend/live/messageSetChannelItem',
        method: 'post',
        data: data
    })
}

export function getLiveCourseInfo(data) {
    return request({
        url: '/backend/live/getLiveCourseInfo',
        method: 'post',
        data: data
    })
}

export function userList(data) {
    return request({
        url: '/backend/live/userList',
        method: 'post',
        data: data
    })
}
export function getAwardStatList(data) {
    return request({
        url: '/backend/live/getAwardStatList',
        method: 'post',
        data: data
    })
}
export function getBindProductSimpleInfo(data) {
    return request({
        url: '/backend/live/getBindProductSimpleInfo',
        method: 'post',
        data: data
    })
}
export function bindAwardProduct(data) {
    return request({
        url: '/backend/live/bindAwardProduct',
        method: 'post',
        data: data
    })
}
export function deleteLiveBindProduct(data) {
    return request({
        url: '/backend/live/deleteLiveBindProduct',
        method: 'post',
        data: data
    })
}
export function getGiveProductList(data) {
    return request({
        url: '/backend/live/getGiveProductList',
        method: 'post',
        data: data
    })
}
export function handleGiveProduct(data) {
    return request({
        url: '/backend/live/handleGiveProduct',
        method: 'post',
        data: data
    })
}
export function getUserCheckinInfo(data) {
    return request({
        url: '/backend/live/getUserCheckinInfo',
        method: 'post',
        data: data
    })
}
export function getChatMsg(data) {
    return request({
        url: '/backend/live/getChatMsg',
        method: 'post',
        data: data
    })
}
export function exportChatMsgExcel(data) {
    return request({
        url: '/backend/live/exportChatMsg',
        method: 'post',
        data: data,
        responseType: 'blob'
    })
}
export function getQaStat(data) {
    return request({
        url: '/backend/live/getQaStat',
        method: 'post',
        data: data
    })
}
export function getEvaluationStat(data) {
    return request({
        url: '/backend/live/getEvaluationStat',
        method: 'post',
        data: data
    })
}
export function exportRoomPraiseStat(data) {
    return request({
        url: '/backend/live/exportRoomPraiseStat',
        method: 'post',
        data: data
    })
}
export function getAttentionList(data) {
    return request({
        url: '/backend/live/getAttentionList',
        method: 'post',
        data: data
    })
}
export function exportAnswerStat(data) {
    return request({
        url: '/backend/live/exportAnswerStat',
        method: 'post',
        data: data
    })
}
export function getRoomQuiz(data) {
    return request({
        url: '/backend/live/getRoomQuiz',
        method: 'post',
        data: data
    })
}
export function getQuizUserAnswer(data) {
    return request({
        url: '/backend/live/getQuizUserAnswer',
        method: 'post',
        data: data
    })
}
export function getQuestionnaireStat(data) {
    return request({
        url: '/backend/live/getQuestionnaireStat',
        method: 'post',
        data: data
    })
}
export function getShareClickList(data) {
    return request({
        url: '/backend/live/getShareClickList',
        method: 'post',
        data: data
    })
}
export function getFakeChatMsgList (data) {
    return request({
        url: '/backend/live/getFakeMessageList',
        method: 'post',
        data: data
    })
}
export function delFakeMsg (data) {
    return request({
        url: '/backend/live/deleteFakeMessage',
        method: 'post',
        data: data
    })
}
export function insertQueue (data) {
    return request({
        url: '/backend/live/insertQueue',
        method: 'post',
        data: data,
        timeout: 1000000
    })
}
export function initLiveChatMessage(data) {
    return request({
        url: '/backend/live/initLiveChatMessage',
        method: 'post',
        data: data
    })
}
export function getLiveChatMessage(data) {
    return request({
        url: '/backend/live/getLiveChatMessage',
        method: 'post',
        data: data
    })
}
export function batchFakeMessage(data) {
    return request({
        url: '/backend/live/batchFakeMessage',
        method: 'post',
        data: data
    })
}
export function fakeMessage(data) {
    return request({
        url: '/backend/live/fakeMessage',
        method: 'post',
        data: data
    })
}
export function deleteInitFakeMessage(data) {
    return request({
        url: '/backend/live/deleteInitFakeMessage',
        method: 'post',
        data: data
    })
}
export function setNewFakeMsg (data) {
    return request({
        url: '/backend/live/setNewFakeMsg',
        method: 'post',
        data: data
    })
}

export function createELive (data) {
    return request({
        url: '/backend/live/createELive',
        method: 'post',
        data: data
    })
}

export function syncELive (data) {
    return request({
        url: '/backend/live/syncELive',
        method: 'post',
        data: data
    })
}

export function advanceStopLive (data) {
    return request({
        url: '/backend/live/advanceStopLive',
        method: 'post',
        data: data
    })
}
export function cleanFakeMessage (data) {
    return request({
        url: '/backend/live/cleanFakeMessage',
        method: 'post',
        data: data
    })
}
export function setBatchMsgTime (data) {
    return request({
        url: '/backend/live/setBatchMsgTime',
        method: 'post',
        data: data
    })
}
export function getCourseInfo (data) {
    return request({
        url: '/backend/live/getCourseInfo',
        method: 'post',
        data: data
    })
}
export function getBlessingBagList (data) {
    return request({
        url: '/backend/live/blessingBag/getBlessingBagList',
        method: 'post',
        data: data
    })
}
export function getBlessingBagWechat (data) {
    return request({
        url: '/backend/live/blessingBag/getBlessingBagWechat',
        method: 'post',
        data: data
    })
}
export function modifyBlessingBagWechat (data) {
    return request({
        url: '/backend/live/blessingBag/modifyBlessingBagWechat',
        method: 'post',
        data: data
    })
}
export function sendBlessingBag(data) {
    return request({
        url: '/backend/live/blessingBag/sendBlessingBag',
        method: 'post',
        data: data
    })
}

//中奖记录列表数据
export function getWinnerList(data) {
    return request({
        url: '/backend/live/blessingBag/getWinnerList',
        method: 'post',
        data: data
    })
}

//关联习题
export function getExerciseQuestions(data) {
    return request({
        url: '/backend/exerciseQuestion/exercise-title/list',
        method: 'post',
        data: data
    })
}